import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { QuestionnaireEditModule } from "@/modules/newCommunity/pages/operationTools/dynimicStore";
let SingleChoice = class SingleChoice extends Vue {
  constructor() {
    super(...arguments);
    this.newArr = [];
  }
  // eslint-disable-next-line
  watchIndex() {}
  dataChage(value) {
    this.zItem = value;
  }
  get questionnaireType() {
    return this.businessType || QuestionnaireEditModule.questionnaireType;
  }
};
__decorate([Prop({
  type: Number,
  default: {}
})], SingleChoice.prototype, "zIndex", void 0);
__decorate([Prop({
  type: Boolean,
  default: true
})], SingleChoice.prototype, "showScore", void 0);
__decorate([Prop({
  type: String,
  default: ""
})], SingleChoice.prototype, "businessType", void 0);
__decorate([Prop({
  type: Boolean,
  default: true
})], SingleChoice.prototype, "Required", void 0);
__decorate([Watch("zIndex", {
  immediate: true
})], SingleChoice.prototype, "watchIndex", null);
__decorate([Prop({
  type: Object,
  default: {}
})], SingleChoice.prototype, "item", void 0);
__decorate([Watch("item", {
  immediate: true,
  deep: true
})], SingleChoice.prototype, "dataChage", null);
SingleChoice = __decorate([Component({
  name: "singleChoice"
})], SingleChoice);
export default SingleChoice;